/* tslint:disable */
/* eslint-disable */
/* @relayHash f640be0236b6cb24fbc80bbd6e9d310e */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type homepageRootQueryVariables = {
    isMobile: boolean;
    homepageId: string;
    userId: string;
    hasUserId: boolean;
    isClient: boolean;
    fetchInitialHomepage: boolean;
    zipCode?: string | null;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
    locationItemsCount?: number | null;
};
export type homepageRootQueryResponse = {
    readonly viewer: {
        readonly homepage: {
            readonly metadata: {
                readonly title: string | null;
                readonly description: string | null;
            } | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespLayout_viewer">;
    };
};
export type homepageRootQuery = {
    readonly response: homepageRootQueryResponse;
    readonly variables: homepageRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isMobile",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "homepageId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchInitialHomepage",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "zipCode",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "locationItemsCount",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "homepageId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "metadata",
  "storageKey": null,
  "args": null,
  "concreteType": "HomepageMetadata",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cta",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageCopy",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFullBleedImage",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageHeight",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageWidth",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "Condition",
  "passingValue": false,
  "condition": "isMobile",
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mobileImageUrl",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mobileImageHeight",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mobileImageWidth",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "isMobile",
  "selections": [
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cmsId",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
},
v22 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "isMobile",
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v16/*: any*/)
  ]
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "items",
  "storageKey": null,
  "args": null,
  "concreteType": "Product",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v8/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v9/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v25 = [
  (v6/*: any*/),
  (v2/*: any*/)
],
v26 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v27 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "masterOrZoomPath",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seller",
  "storageKey": null,
  "args": null,
  "concreteType": "Seller",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v29/*: any*/)
  ]
},
v32 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  }
],
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pricing",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPricing",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "retailPrice",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": (v32/*: any*/)
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v38 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "homepageRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "homepage",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Homepage",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "HpRespLayout_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "homepageRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isDiscoverPageDisabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_DISCOVERY_PAGE"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_DISCOVERY_PAGE\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "homepage",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Homepage",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "modules",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchInitialHomepage",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "SkinnyBannerModule",
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SkinnyBannerModuleItem",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v15/*: any*/),
                              (v19/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "TopHeroBannerModule",
                        "selections": [
                          (v6/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TopHeroBannerItem",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/),
                              (v15/*: any*/),
                              (v22/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "HeroModule",
                        "selections": [
                          (v6/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "link",
                                "args": null,
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              (v2/*: any*/),
                              (v23/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CollectionsModule",
                        "selections": [
                          (v6/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v2/*: any*/),
                              (v12/*: any*/),
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "FeaturedModule",
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "primaryItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FeaturedItem",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FeaturedItem",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v9/*: any*/),
                              (v12/*: any*/),
                              (v2/*: any*/),
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "PromoModule",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalItemsCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "index",
                            "args": null,
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PromoItem",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v8/*: any*/),
                              (v11/*: any*/),
                              (v15/*: any*/),
                              (v19/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "EditorialModule",
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "EditorialItem",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v8/*: any*/),
                              (v3/*: any*/),
                              (v9/*: any*/),
                              (v12/*: any*/),
                              (v14/*: any*/),
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ShopByModule",
                        "selections": [
                          (v6/*: any*/),
                          (v2/*: any*/),
                          (v24/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "LocationsModule",
                        "selections": [
                          (v6/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subtitle",
                            "args": null,
                            "storageKey": null
                          },
                          (v24/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "location",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Location",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LocationItem",
                                "plural": true,
                                "selections": [
                                  (v20/*: any*/),
                                  (v2/*: any*/),
                                  (v8/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ArrivalsModule",
                        "selections": (v25/*: any*/)
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "RecentlyViewedModule",
                        "selections": (v25/*: any*/)
                      }
                    ]
                  }
                ]
              },
              (v4/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "personalization",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 3
                      },
                      {
                        "kind": "Literal",
                        "name": "numItems",
                        "value": 3
                      },
                      (v26/*: any*/)
                    ],
                    "concreteType": "PersonalizationModuleConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PersonalizationModuleEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PersonalizationModule",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "categoryTitle",
                                "args": null,
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "categoryMainItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "photos",
                                    "storageKey": "photos(limit:1)",
                                    "args": (v27/*: any*/),
                                    "concreteType": "ItemPhoto",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "alt",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v28/*: any*/),
                                      (v29/*: any*/)
                                    ]
                                  },
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v23/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "variant",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "categoryItems",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "localizedPdpUrl",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v30/*: any*/),
                                  (v23/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isCustomizable",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isMultiSku",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "vertical",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shipmentQuotes",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ShipmentQuote",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isComplimentary",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "totalAmount",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FinancialAmount",
                                        "plural": false,
                                        "selections": (v32/*: any*/)
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "serviceMethod",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ShipmentServiceMethod",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "region",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Region",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "regionName",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v29/*: any*/)
                                            ]
                                          },
                                          (v29/*: any*/)
                                        ]
                                      },
                                      (v29/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "classification",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ItemClassification",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "creationDate",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "creators",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ItemCreator",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "attribution",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "creator",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Creator",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v29/*: any*/)
                                        ]
                                      },
                                      (v29/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": "productPhotos",
                                    "name": "photos",
                                    "storageKey": "photos(limit:1)",
                                    "args": (v27/*: any*/),
                                    "concreteType": "ItemPhoto",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "placeholder",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "smallPath",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v28/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "versions",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ItemPhotoVersion",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "webPath",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v29/*: any*/)
                                    ]
                                  },
                                  (v21/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "quickViewDisplay",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "QuickViewDisplayType",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": "mobileTitle",
                                        "name": "title",
                                        "args": (v35/*: any*/),
                                        "storageKey": "title(formatType:\"MOBILE\")"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "paragraphs",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "QuickViewParagraph",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "key",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "text",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": "mobileText",
                                            "name": "text",
                                            "args": (v35/*: any*/),
                                            "storageKey": "text(formatType:\"MOBILE\")"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "paragraphAttributeNames",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "QuickViewCategorySegments",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "period",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "origin",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "style",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "periodPrefix",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "creators",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "QuickViewCreator",
                                        "plural": true,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v8/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v29/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v29/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "locationItemsInfo",
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "regionTypes",
                    "value": "ITEM_LOCATION"
                  },
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "zipCode"
                  }
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "locationPage",
                    "storageKey": "locationPage(maxWeight:\"METROPOLITAN\",minCount:1,minWeight:\"DISTRICT\",usOnly:true)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxWeight",
                        "value": "METROPOLITAN"
                      },
                      {
                        "kind": "Literal",
                        "name": "minCount",
                        "value": 1
                      },
                      {
                        "kind": "Literal",
                        "name": "minWeight",
                        "value": "DISTRICT"
                      },
                      {
                        "kind": "Literal",
                        "name": "usOnly",
                        "value": true
                      }
                    ],
                    "concreteType": "LocationPage",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "locationItemsCount"
                          }
                        ],
                        "concreteType": "Item",
                        "plural": true,
                        "selections": [
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v30/*: any*/),
                          (v23/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstPhotoWebPath",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "master"
                              }
                            ],
                            "storageKey": "firstPhotoWebPath(size:\"master\")"
                          },
                          (v8/*: any*/),
                          (v31/*: any*/),
                          (v2/*: any*/),
                          (v29/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v29/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  (v26/*: any*/)
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUserRecentHistoryItem",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "storageKey": null,
                        "args": (v38/*: any*/),
                        "concreteType": "RecentHistoryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RecentHistoryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstPhotoWebPath",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "small"
                                      }
                                    ],
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pdpURL",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "categoryPath",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v31/*: any*/),
                                  (v29/*: any*/),
                                  (v5/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "args": (v38/*: any*/),
                        "handle": "connection",
                        "key": "getRecentHistory_recentHistoryItems",
                        "filters": [
                          "excludeItemPks"
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "homepageRootQuery",
    "id": "app-buyer-misc/267.0.0-2020-06-04T13:08:16.644Z/homepageRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '80ef169703b6a94267b32b3e5fb678d1';
export default node;
